import { atom } from 'jotai';

export const isCompleteVisibleAtom = atom<boolean>(false);

export interface GiftRecipient {
    name: string;
    phoneNo: string;
}

export const giftRecipientsAtom = atom<GiftRecipient[]>([]);

export const MAX_GIFT_RECIPIENTS = 10;
